import { removeSessionStorage } from 'helpers/common'
import * as exchangeToken from 'helpers/exchangeToken'

export function clearLogoutLocalState(): void {
  removeSessionStorage('isMenuOpen')
  removeSessionStorage('pathRedirect')
  removeSessionStorage('consents')
  removeSessionStorage('countExchange')
  exchangeToken.clearAuthenticationFinished()
}
